import { createApp } from 'vue';
import LanguageMenu from "../app-header-menu/components/LanguageMenu.vue";

if (document.getElementById('language-menu')) {
    createApp({
    })
        .component('LanguageMenu', LanguageMenu)
        .mount("#language-menu")
}
